import type {STIpApiLocation} from "api/ipApi/ipapi";

type TGeoLocation = Partial<STIpApiLocation> | null | undefined;

// ISO 3166-1 alpha-2, as returned by ipapi.co in `country`.
// Sanctioned countries: the whole app is unavailable from here.
export const SANCTIONED_COUNTRY_CODES = ["RU", "KP", "CU", "IR"];

// Self sign-up only (MAPX-90, MAPX-461): existing users from here can still log in.
export const SIGNUP_BLOCKED_COUNTRY_CODES = ["CN", "IN"];

export const isSanctionedLocation = (location: TGeoLocation): boolean =>
	!!location?.country && SANCTIONED_COUNTRY_CODES.includes(location.country);

export const isSignupBlockedLocation = (location: TGeoLocation): boolean =>
	isSanctionedLocation(location) ||
	(!!location?.country && SIGNUP_BLOCKED_COUNTRY_CODES.includes(location.country));
